<label class="toggle" [ngClass]="{'disabled': disabled}">
  <input type="checkbox" [checked]="isActive" (change)="toggleChanged()" [disabled]="disabled" />
  <span class="slider round"></span>
</label>
